/**
 * Available locales for the site.
 * Start with the same 3 languages as Motion Mapper (en, es, fr) plus Japanese,
 * Simplified Chinese, and Arabic for games.
 * The infrastructure supports adding more languages later.
 */
export const AVAILABLE_LOCALES = [
  "en",
  "id",
  "de",
  "es",
  "fr",
  "it",
  "nl",
  "pl",
  "pt-BR",
  "fi",
  "sv",
  "vi",
  "tr",
  "ru",
  "ar",
  "hi",
  "th",
  "ko",
  "ja",
  "zh-CN",
] as const;

export type SiteLocale = (typeof AVAILABLE_LOCALES)[number];

export const DEFAULT_LOCALE: SiteLocale = "en";

export const LOCALE_LABELS: Record<SiteLocale, string> = {
  en: "English",
  es: "Español",
  fr: "Français",
  ja: "日本語",
  "zh-CN": "简体中文",
  ar: "العربية",
  "pt-BR": "Português (Brasil)",
  de: "Deutsch",
  ru: "Русский",
  ko: "한국어",
  hi: "हिन्दी",
  id: "Bahasa Indonesia",
  tr: "Türkçe",
  vi: "Tiếng Việt",
  th: "ไทย",
  fi: "Suomi",
  pl: "Polski",
  sv: "Svenska",
  nl: "Nederlands",
  it: "Italiano",
};

/**
 * Check if a string is a valid site locale
 */
export function isValidLocale(locale: string): locale is SiteLocale {
  return AVAILABLE_LOCALES.includes(locale as SiteLocale);
}

/**
 * Get a valid locale from a string, falling back to default
 */
export function resolveLocaleOrDefault(locale?: string): SiteLocale {
  if (locale && isValidLocale(locale)) {
    return locale;
  }
  return DEFAULT_LOCALE;
}
